// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b86257cd","129":"00cd7263","289":"2301e4c7","304":"d46bb51a","348":"aac1c922","356":"0a9e77ee","392":"ea862e5c","444":"cbf41e6c","536":"5c4aee47","622":"3cb55926","808":"9071fe7e","833":"6017a2b5","924":"f37f973f"}[chunkId] + ".chunk.js";
};